// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"963161aa","977":"41bae21f"}[chunkId] + ".chunk.js";
};